/// <reference types="node" />
import "./app";


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/entry.ts
 **/